<mat-dialog-content>
    <div class="row" style="height: 100%;">
        <div class="col-12" style="height: 100%;">
            <div class="stickyHeader">
                <a class="close-button stickyHeader" (click)="cancelled()"><span
                        class="icon-remove close-button"></span></a>
                <h2>create client secret keyvault config</h2>
            </div>

            <div class="dialog-wrapper adjustStickyHeader" style="height: 94%;max-height: 1000px;">
                <create-client-secret-auto-rotation-config-form [makeSticky]="true" [isDialog]="true"
                    [serviceId]="data.serviceId" [appId]="data.appId"
                    (newIdmClientSecretAutoRotationConfig)="saveConfig($event)" (cancelled)="cancelled()">
                </create-client-secret-auto-rotation-config-form>
            </div>
        </div>
    </div>
</mat-dialog-content>